module.exports = __webpack_public_path__ + "img/UTQUAI-3.31dcc479.jpg";